/* ZSchedaGenerica
Versione 1.17.9 - 13 Aprile 2026 - Alessio Verardo
                  - NEW: Inserite le funzioni DisponiFromHour e la PrepareForRecordHour
Versione 1.16.9 - 04 Febbraio 2026 - Mauro Brasile
                  - CHG: Aggiunto valore di default selezionabile per la DisponiFromEnum e PrepareForRecordEnum
Versione 1.15.9 - 12 Gennaio 2026 - Mauro Brasile
                  - NEW: Aggiunte le funzioni DisponiFromMonth e PrepareForRecordMonth 
Versione 1.14.9 - 28 Aprile 2025 - Enrico Mazzoleni
                  - NEW: Aggiunta la FunzNodo2
Versione 1.13.9 - 25 Ottobre 2024 - Mauro Brasile
                  - FIX: Aggiunta chiamata OnSuccess nella disponi (se esiste)
                  - FIX: Aggiunto valore di default nella prepare for record time
Versione 1.13.8 - 25 Ottobre 2024 - Mauro Brasile
                  - NEW: Aggiunta la funzione DisponiFromDateTime
Versione 1.12.8 - 23 Maggio 2024 - Daniele Gallesio
                  - NEW: Aggiunta la funzione DisponiFromAnnoMese che trasforma 202405 in "Maggio 2024"
Versione 1.11.8 - 12 Febbraio 2024 - Mauro Brasile
                 - FIX: La prepare non trasformava in stringa il valore passato
Versione 1.11.7 - 04 Gennaio 2024 - Massimiliano Zirilli 
                 - NEW: Aggiunta la funzione per assegnare la chiave della scheda senza caricare il riassunto dei dati
                 - NEW: Aggiunto il segnaposto per la funziona CaricaRiassunto
Versione 1.10.7 - 09 Novembre 2023 - Massimiliano Zirilli / MauroBrasile
                 - NEW: Aggiunta variabile globale per impostare i caratteri
                        in UpperCase, in LowerCase o invariato nella disponi e nella prepare delle stringhe,
                        inserito il parametro ignorecharchase per evitare la funzionalita nelle varie funzioni
                 - NEW: Aggiunta la procedura PrepareForRecordEnum e DisponiFromEnum
Versione 1.9.7 - 31 Ottobre 2023 - Mauro Brasile
                 - NEW: Aggiunta OnSuccess alla funzione Disponi
Versione 1.8.7 - 18 Settembre 2023 - Massimiliano Zirilli
                 - FIX: Le prepare di data e ora non gestivano il dato in formato Date
                 - NEW: Aggiunta la PrepareForRecordDateTime
Versione 1.7.6 - 02 Agosto 2023 - Mauro Brasile
                 - NEW: La FunzNodo1 passa il parametro nodo
Versione 1.6.6 - 25 Luglio 2023 - Mauro Brasile
                 - NEW: Aggiunto nuovo metodo DatiInviabili e la relativa funzione Invia
Versione 1.5.6 - 24 Luglio 2023 - Francesco Ardini
                 - FIX: Risolto bug nella DisponiFromBoolean
Versione 1.5.5 - 15 Giugno 2023 - Francesco Ardini
                 - FIX: rimossa funzione ripetuta "DatiStampabili"
Versione 1.5.4 - 14 Giugno 2023 - Massimiliano Zirilli
                 - NEW: Aggiunta funzionalità 1 aggiuntiva
Versione 1.4.4 - 13 Giugno 2023 - Massimiliano Zirilli
                 - FIX: Errore arrotondamento interi in PrepareForRecordInteger
Versione 1.4.3 - 16 Maggio 2023 - Mauro Brasile
                 - NEW: Aggiunta la prepare e la disponi per time
Versione 1.3.3 - 16 Maggio 2023 - Massimiliano  Zirilli
                 - FIX: Eliminato metodo GetPositionOnTree perchè già presente la GetFiltriAbilitati
Versione 1.3.2 - 16 Maggio 2023 - Massimiliano  Zirilli
                 - NEW: Aggiunta funzione PrepareForRecordDate
                 - FIX: Le prepare e le disponi ora sono funzioni static, possono essere richiamate anche al di fuori della classe 
Versione 1.2.1 - 26 Aprile 2023 - Massimiliano  Zirilli
                 - NEW: Aggiunte procedure per la gestione della stampa
Versione 1.1.1 - 28 Marzo 2023 - Massimiliano  Zirilli
                 - FIX: PrepareForRecordString non gestiva il caso undefined
Versione 1.1.0 - 02 Marzo 2023 - Massimiliano  Zirilli
                 - NEW: Aggiunto il metodo nuovo
Versione 1.0.0 - 15 Agosto 2022 - Massimiliano  Zirilli
                 - Prima versione
*/

import { TZDateFunct } from "./ZDateFunct.js"

export const TSchedaGenericaCharCase = {
                                          TuttoMinuscolo : 'L',
                                          TuttoMaiuscolo : 'U',
                                          NonModificare  : '-'
                                        }  

export var SchedaGenericaConfigurazione = {
                                            CharCase : TSchedaGenericaCharCase.NonModificare
                                          }                                             

export class TSchedaGenerica 
{
   constructor(AdvQuery)
   {
     this.AdvQuery = AdvQuery;
     this.InEliminazione = false;
     this.OnInitialization();
     this.Clear();
   }

   OnInitialization()
   {
    
   }

   static PrepareForRecordListIndex(Value)
   {
    return (parseInt(Value) == -1 ? null : parseInt(Value));
   }

   static DisponiFromListIndex(Value)
   {
     if(Value == undefined || Value == null)
        return -1;
     return parseInt(Value);
   }

   static PrepareForRecordInteger(Value)
   {
     if(typeof Value === 'string')
        return parseInt(Value)
     return Math.round(Value)
   }

   static DisponiFromInteger(Value)
   {
     if(Value == undefined || Value == null)
        return 0;
     return parseInt(Value);
   }

   static PrepareForRecordDouble(Value,NrDecimali)
   {
     return Math.round(Value * Math.pow(10,NrDecimali));
   }

   static DisponiFromDouble(Value,NrDecimali)
   {
     if(Value == undefined || Value == null)
        return 0;
     return parseInt(Value) / Math.pow(10,NrDecimali);
   }

   static PrepareForRecordBoolean(Value)
   {
     return Value ? 'T' : 'F'
   }

   static DisponiFromBoolean(Value)
   {
      if(Value == undefined || Value == null)
         return false;
      return Value == 'T';
   }

   static PrepareForRecordString(Value, IgnoreCharCase)
   {
     if(Value == undefined || Value == null) 
        return '';
     if(!IgnoreCharCase)
     {
        Value = Value + ''
        switch(SchedaGenericaConfigurazione.CharCase)
        {
          case TSchedaGenericaCharCase.TuttoMaiuscolo  : Value = Value.toUpperCase()
                                                          break;
          case TSchedaGenericaCharCase.TuttoMinuscolo  : Value = Value.toLowerCase()
                                                          break;                                                    
        }
     }
     return Value.trim();
   }

   static DisponiFromString(Value, IgnoreCharCase)
   {
      if(Value == undefined || Value == null)
        return '';
      if(!IgnoreCharCase)
      {
        switch(SchedaGenericaConfigurazione.CharCase)
        {
          case TSchedaGenericaCharCase.TuttoMaiuscolo  : Value = Value.toUpperCase()
                                                        break;
          case TSchedaGenericaCharCase.TuttoMinuscolo  : Value = Value.toLowerCase()
                                                        break;                                                    
        }
      }
      return (Value + '').trim();
   }

   static DisponiFromEnum(Value, NullValue = '')
   {
      if(Value == undefined || Value == null)
        return NullValue;
      return (Value + '').trim();
   }

   static PrepareForRecordEnum(Value, NullValue = '')
   {
     if(Value == undefined || Value == null) 
        return NullValue;
     return Value.trim();
   }

   static DisponiFromDate(Value)
   {
      if(Value == undefined || Value == null || Value == '0000-00-00')
         return '';
      return (Value + '').trim();
   }

   static DisponiFromHour(Value)
   {
      if(Value == undefined || Value == null)
        return '';
      return (Value).trim();
   }

   static DisponiFromDateTime(Value)
   {
      if(Value == undefined || Value == null || Value == '0000-00-00 00:00:00')
         return '';
      return (Value + '').trim();
   }

   static DisponiFromAnnoMese(AnnoMese)
   {
     if(AnnoMese == -1 || AnnoMese == undefined || AnnoMese == null)
       return ''
     else
     {
       let Anno = Math.trunc(AnnoMese / 100)
       let Mese = AnnoMese % 100
       Mese = TZDateFunct.GetMesiInItaliano()[Mese - 1]
       let StringaMeseAnno = Mese + ' ' + Anno.toString()
       return StringaMeseAnno
     }
   }

   static PrepareForRecordDate(Value)
   {
      if(Value == undefined || Value == '' || Value == '0000-00-00')
         return null;
      if (Value instanceof Date)
         Value = TZDateFunct.FormatDateTime('yyyy-mm-dd',Value)
      return Value;
   }

   static PrepareForRecordDateTime(Value)
   {
      if(Value == undefined || Value == '')
         return null;
      if (Value instanceof Date)
         Value = TZDateFunct.FormatDateTime('yyyy-mm-dd hh:nn:ss',Value)
      return Value;
   }

   static PrepareForRecordHour(Value)
   {
    if(Value == undefined || Value == '')
        return null;
    if (Value instanceof Date)
        Value = TZDateFunct.FormatDateTime('hh:nn:ss',Value)
    return Value;
   }

   static PrepareForRecordMonth(Value)
   {
      //Arriva il valore di VUEInputMeseAnno
      let Result = null;
      if(Value != undefined && Value != null && Value.length == 7)
      {
        Result = parseInt(Value.substring(0,4) + Value.substring(5,7))
        if(Result == 0) 
          Result = null;
      }
      return Result
   }

   static DisponiFromMonth(Value)
   {
      let Result = ''
      if(Value == undefined || Value == null) 
        Result = ''
      else 
      {
        Value += '' 
        if(Value.length != 6)
          Result = ''
        else 
        {
            let ValoreDBase = parseInt(Value)
            let Anno = Math.trunc(ValoreDBase / 100)
            let Mese = ValoreDBase % 100
            Result = Anno.toString() + '-' + (Mese < 10 ? '0' : '') + Mese.toString()
        }
      }
      return Result;
   }

   static DisponiFromTime(Value)
   {
      if(Value == undefined || Value == null || Value == '00:00:00' || Value == '00-00-00')
         return '';
      return (Value + '').trim();
   }

   static PrepareForRecordTime(Value)
   {
      if(Value == undefined || Value == '' || Value == '00:00:00' || Value == '00-00-00')
         return null;
      if (Value instanceof Date)
         Value = TZDateFunct.FormatDateTime('hh:nn:ss',Value)
      return Value;
   }

   GetClassName()
   {
     return 'TSchedaGenerica';
   }

   GetFiltriAbilitati()
   {
     return []
   }

   GetDescrizione()
   {
     return "Scheda vuota"
   }

   GetImageIndex()
   {
     return '';
   }

   GetStateIndex()
   { 
      return '';
   }

   Disponi(OnSuccess)
   {
      if(OnSuccess != undefined)
        OnSuccess()
   }

   Nuovo()
   {
     this.Chiave = -1;
   }

   IsNuovo()
   {
     return this.Chiave == -1;
   }

   DatiEliminabili()
   {
     return false;
   }

   DatiStampabili()
   {
      return false;
   }

   DatiInviabili()
   {
      return false;
   }

   FunzNodo1Abilitata()
   {
     return false
   }

   FunzNodo1Icona()
   {
     return ''
   }

   FunzNodo1(Nodo)
   {
   }

   FunzNodo1Messaggio()
   {
     return ''
   }

   FunzNodo2Abilitata()
   {
     return false
   }

   FunzNodo2Icona()
   {
     return ''
   }

   FunzNodo2(Nodo)
   {
   }

   FunzNodo2Messaggio()
   {
     return ''
   }

   Stampa(OnSuccess)
   {
   }
   
   Elimina()
   {
   }

   Invia(OnSuccess)
   {
   }

   Registra(OnSuccess,OnError)
   {
   }

   CanRecord()
   {
     return false;
   }

   Clear()
   {
     this.Chiave = -1;
     this.CreateSnapshot();
   }

   CreateSnapshot()
   {
     this.Snapshot = JSON.stringify(this.Dati);
   }

   // Questo metodo serve solo se la scheda mi è utile solo con la chiave
   SetKey(Chiave)
   {
     this.Chiave = Chiave
   }

   CaricaRiassunto(Riassunto)
   {
   }

   DatiModificati()
   {
     
     //LASCIO QUESTO CODICE NEL CASO MI RITROVO UN DATO CHE RISULTA MODIFICATO QUANDO NON DOVREBBE
    //  if(this.Snapshot != JSON.stringify(this.Dati))
    //    if(this.GetClassName() == 'TSchedaCorso')
    //    {
    //      console.log('KAMEHAMEHA')
    //      console.log(this.Snapshot)
    //      console.log(JSON.stringify(this.Dati))
    //    }
     return this.Snapshot != JSON.stringify(this.Dati);
   }

}
